import { Head } from '@inertiajs/react';
import type { ArcadeHack25MachinesIndex } from '@/types';
import { ArcadeMachine } from './components/arcade-machine';

export default function Index({ games }: ArcadeHack25MachinesIndex) {
  return (
    <>
      <Head title="Arcade Machine | Platanus Hack 25">
        <meta
          name="description"
          content="Play arcade games on the Platanus Hack 25 arcade machine"
        />
      </Head>
      <div className="min-h-screen bg-black">
        <ArcadeMachine games={games} />
      </div>
    </>
  );
}
